var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ladding web-bg" },
    [
      _c("background"),
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "index_container custom-container-xl" },
          [
            _c(
              "v-layout",
              {
                attrs: {
                  row: "",
                  wrap: "",
                  "fill-height": "",
                  "align-center": ""
                }
              },
              [
                _c(
                  "v-flex",
                  { staticClass: "header__wrap", attrs: { xs12: "", md5: "" } },
                  [
                    _c("h1", { staticClass: "header__text" }, [
                      _c("div", { staticClass: "header__title" }, [
                        _vm._v("ASTRORG")
                      ]),
                      _c("div", { staticClass: "header__sub" }, [
                        _vm._v("INTERCONNECTED ECOSYSTEM")
                      ]),
                      _c("div", { staticClass: "header__content" }, [
                        _vm._v("专属于你的随身占星师")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "header__btn cta-btn",
                          on: {
                            click: function($event) {
                              return _vm.goToSection("singlePan")
                            }
                          }
                        },
                        [_vm._v("\n              深入了解\n            ")]
                      )
                    ])
                  ]
                ),
                _c(
                  "v-flex",
                  {
                    staticClass: "header-pan",
                    attrs: { xs12: "", md7: "", "fill-height": "" }
                  },
                  [
                    _c("img", {
                      staticClass: "header_bg",
                      attrs: {
                        src: require("@/assets/WebPage/header-pan.svg"),
                        alt: "header"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "services" }, [
        _c(
          "div",
          { staticClass: "index_container custom-container-xl" },
          [
            _c(
              "v-layout",
              {
                staticClass: "services__container",
                attrs: { row: "", "fill-height": "", "align-center": "" }
              },
              [
                _c(
                  "div",
                  { staticClass: "services__wrap" },
                  [
                    _c(
                      "v-layout",
                      {
                        staticClass: "services__item",
                        attrs: {
                          "align-center": "",
                          "justify-center": "",
                          column: ""
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.goToSection("singlePan")
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "services__item__img",
                              attrs: {
                                src: require("@/assets/WebPage/service_1.svg"),
                                alt: "个人星盘"
                              }
                            })
                          ]
                        ),
                        _c(
                          "h2",
                          {
                            staticClass: "services__item__title",
                            on: {
                              click: function($event) {
                                return _vm.goToSection("singlePan")
                              }
                            }
                          },
                          [_vm._v("\n              星座命盤\n            ")]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "services__item__content hidden-sm-and-down",
                            on: {
                              click: function($event) {
                                return _vm.goToSection("singlePan")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              提供个人本命盘及双人合盘，星座、宫位、相位全收录，占星排盘不求人。\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "services__wrap" },
                  [
                    _c(
                      "v-layout",
                      {
                        staticClass: "services__item",
                        attrs: {
                          "align-center": "",
                          "justify-center": "",
                          column: ""
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.goToSection("doublePan")
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "services__item__img",
                              attrs: {
                                src: require("@/assets/WebPage/icon_couple.svg"),
                                alt: "双人合盘"
                              }
                            })
                          ]
                        ),
                        _c(
                          "h2",
                          {
                            staticClass: "services__item__title",
                            on: {
                              click: function($event) {
                                return _vm.goToSection("doublePan")
                              }
                            }
                          },
                          [_vm._v("\n              双人合盘\n            ")]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "services__item__content hidden-sm-and-down",
                            on: {
                              click: function($event) {
                                return _vm.goToSection("doublePan")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              分析两人的契合度与互动模式，快速掌握关系中的重点议题。\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "services__wrap" },
                  [
                    _c(
                      "v-layout",
                      {
                        staticClass: "services__item",
                        attrs: {
                          "align-center": "",
                          "justify-center": "",
                          column: ""
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.goToSection("transitPan")
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "services__item__img",
                              attrs: {
                                src: require("@/assets/WebPage/icon_service.svg"),
                                alt: "推运功能"
                              }
                            })
                          ]
                        ),
                        _c(
                          "h2",
                          {
                            staticClass: "services__item__title",
                            on: {
                              click: function($event) {
                                return _vm.goToSection("transitPan")
                              }
                            }
                          },
                          [_vm._v("\n              推运功能\n            ")]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "services__item__content hidden-sm-and-down",
                            on: {
                              click: function($event) {
                                return _vm.goToSection("transitPan")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              观察运势节奏与时间变化，协助你安排下一步决策。\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "section sec-1", attrs: { id: "singlePan" } }, [
        _c(
          "div",
          { staticClass: "index_container custom-container-xl" },
          [
            _c(
              "v-layout",
              {
                attrs: {
                  row: "",
                  wrap: "",
                  "fill-height": "",
                  "align-center": ""
                }
              },
              [
                _c(
                  "v-flex",
                  {
                    staticClass: "sec__box flex-s",
                    attrs: { xs12: "", md5: "" }
                  },
                  [
                    _c("img", {
                      staticClass: "oval_1",
                      attrs: {
                        src: require("@/assets/WebPage/Oval(1)_個人星盤.svg"),
                        alt: "装饰"
                      }
                    }),
                    _c("img", {
                      staticClass: "hidden-md-and-up",
                      attrs: {
                        src: require("@/assets/WebPage/icon_personal.svg"),
                        alt: "个人星盘"
                      }
                    }),
                    _c("div", { staticClass: "sec__title" }, [
                      _c("img", {
                        staticClass: "hidden-sm-and-down",
                        attrs: {
                          src: require("@/assets/WebPage/icon_personal.svg"),
                          alt: "个人星盘"
                        }
                      }),
                      _c("h2", [_vm._v("个人星盘")])
                    ]),
                    _c("p", { staticClass: "sec__secend" }, [
                      _vm._v("比你更懂你自己，探索自我的无限可能")
                    ]),
                    _c("p", { staticClass: "sec__content" }, [
                      _vm._v(
                        "\n            线上量身绘制本命盘，提供详尽的个人星座、宫位、相位等信息，深入剖析个人特质与优劣势。\n          "
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "sec__btn",
                        on: { click: _vm.toSinglePan }
                      },
                      [_vm._v("马上使用")]
                    )
                  ]
                ),
                _c(
                  "v-flex",
                  {
                    staticClass: "sec__space sec__space-1",
                    attrs: { xs12: "", md7: "" }
                  },
                  [
                    _c("img", {
                      staticClass: "img_main",
                      attrs: {
                        src: require("@/assets/WebPage/星盤_個人星盤.png"),
                        alt: "个人星盘"
                      }
                    }),
                    _c("img", {
                      staticClass: "img_side",
                      attrs: {
                        src: require("@/assets/WebPage/Oval(2)_個人星盤.svg"),
                        alt: "个人星盘细节"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "section sec-2", attrs: { id: "doublePan" } }, [
        _c(
          "div",
          { staticClass: "index_container custom-container-xl" },
          [
            _c(
              "v-layout",
              {
                attrs: {
                  row: "",
                  wrap: "",
                  "fill-height": "",
                  "align-center": ""
                }
              },
              [
                _c(
                  "v-flex",
                  {
                    staticClass: "sec__box",
                    attrs: { xs12: "", md5: "", "order-md2": "" }
                  },
                  [
                    _c("img", {
                      staticClass: "hidden-md-and-up",
                      attrs: {
                        src: require("@/assets/WebPage/icon_couple.svg"),
                        alt: "双人合盘"
                      }
                    }),
                    _c("div", { staticClass: "sec__title" }, [
                      _c("img", {
                        staticClass: "hidden-sm-and-down",
                        attrs: {
                          src: require("@/assets/WebPage/icon_couple.svg"),
                          alt: "双人合盘"
                        }
                      }),
                      _c("h2", [_vm._v("双人合盘")])
                    ]),
                    _c("p", { staticClass: "sec__secend" }, [
                      _vm._v("邂逅你的命中注定，为你解读每段缘分")
                    ]),
                    _c("p", { staticClass: "sec__content" }, [
                      _vm._v(
                        "\n            结合两人本命盘进行组合与占算，分析契合度与沟通模式，揭露互动关系与速配指数。\n          "
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "sec__btn",
                        on: { click: _vm.toDoublePan }
                      },
                      [_vm._v("马上占算")]
                    )
                  ]
                ),
                _c(
                  "v-flex",
                  {
                    staticClass: "sec__space sec__space-2",
                    attrs: { xs12: "", md7: "", "order-md1": "" }
                  },
                  [
                    _c("img", {
                      staticClass: "people",
                      attrs: {
                        src: require("@/assets/WebPage/couple_雙人合盤.svg"),
                        alt: "双人合盘"
                      }
                    }),
                    _c("img", {
                      staticClass: "wave",
                      attrs: {
                        src: require("@/assets/WebPage/wave_雙人合盤.svg"),
                        alt: "双人合盘细节"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "section sec-4", attrs: { id: "transitPan" } }, [
        _c(
          "div",
          { staticClass: "index_container custom-container-xl" },
          [
            _c(
              "v-layout",
              {
                attrs: {
                  row: "",
                  wrap: "",
                  "fill-height": "",
                  "align-center": ""
                }
              },
              [
                _c(
                  "v-flex",
                  {
                    staticClass: "sec__box",
                    attrs: { xs12: "", md5: "", "order-md2": "" }
                  },
                  [
                    _c("div", { staticClass: "sec__title" }, [
                      _c("span", [_vm._v("ASTRORG")])
                    ]),
                    _c("p", { staticClass: "sec__secend" }, [
                      _vm._v("你，专属的随身占星师")
                    ]),
                    _c("p", { staticClass: "sec__content" }, [
                      _vm._v(
                        "\n            推运功能协助你追踪趋势与转折，让你更有节奏地规划工作、感情与个人成长。\n          "
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "sec__btn",
                        on: { click: _vm.toTransitPan }
                      },
                      [_vm._v("前往推运")]
                    )
                  ]
                ),
                _c(
                  "v-flex",
                  {
                    staticClass: "sec__space sec__space-4",
                    attrs: { xs12: "", md7: "", "order-md1": "" }
                  },
                  [
                    _c("div", { staticClass: "cup" }, [
                      _c("img", {
                        staticClass: "cup_bg",
                        attrs: {
                          src: require("@/assets/WebPage/漂浮杯杯/top.png"),
                          alt: "推运"
                        }
                      }),
                      _c("img", {
                        staticClass: "cup_bottom",
                        attrs: {
                          src: require("@/assets/WebPage/漂浮杯杯/bottom.png"),
                          alt: "底图"
                        }
                      }),
                      _c("img", {
                        staticClass: "people",
                        attrs: {
                          src: require("@/assets/WebPage/漂浮杯杯/couple.svg"),
                          alt: "推运细节"
                        }
                      }),
                      _c("img", {
                        staticClass: "ball",
                        attrs: {
                          src: require("@/assets/WebPage/漂浮杯杯/金星.svg"),
                          alt: "星体"
                        }
                      })
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _c("img", {
          staticClass: "sec-4_bg",
          attrs: {
            src: require("@/assets/WebPage/漂浮杯杯/wave_ASTRORG.svg"),
            alt: "波浪"
          }
        })
      ]),
      _c("div", { staticClass: "add-line section" }, [
        _c(
          "div",
          { staticClass: "add-line__bg index_container custom-container-xl" },
          [
            _c(
              "v-layout",
              {
                attrs: {
                  row: "",
                  wrap: "",
                  "fill-height": "",
                  "align-center": ""
                }
              },
              [
                _c(
                  "v-flex",
                  {
                    staticClass: "line__box",
                    attrs: { xs12: "", md6: "", "order-md2": "" }
                  },
                  [
                    _c("div", { staticClass: "social" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social === "FB",
                            expression: "social === 'FB'"
                          }
                        ],
                        attrs: {
                          src: require("@/assets/WebPage/social/icon-facebook -color.svg"),
                          alt: "FB"
                        }
                      }),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social !== "FB",
                            expression: "social !== 'FB'"
                          }
                        ],
                        attrs: {
                          src: require("@/assets/WebPage/social/icon-facebook.svg"),
                          alt: "FB"
                        },
                        on: {
                          click: function($event) {
                            _vm.social = "FB"
                          }
                        }
                      }),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social === "Line",
                            expression: "social === 'Line'"
                          }
                        ],
                        attrs: {
                          src: require("@/assets/WebPage/social/icon-line-color.svg"),
                          alt: "Line"
                        }
                      }),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social !== "Line",
                            expression: "social !== 'Line'"
                          }
                        ],
                        attrs: {
                          src: require("@/assets/WebPage/social/icon-line.svg"),
                          alt: "Line"
                        },
                        on: {
                          click: function($event) {
                            _vm.social = "Line"
                          }
                        }
                      }),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social === "IG",
                            expression: "social === 'IG'"
                          }
                        ],
                        attrs: {
                          src: require("@/assets/WebPage/social/icon-instagram-color.svg"),
                          alt: "IG"
                        }
                      }),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social !== "IG",
                            expression: "social !== 'IG'"
                          }
                        ],
                        attrs: {
                          src: require("@/assets/WebPage/social/icon-instagram.svg"),
                          alt: "IG"
                        },
                        on: {
                          click: function($event) {
                            _vm.social = "IG"
                          }
                        }
                      })
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social === "FB",
                            expression: "social === 'FB'"
                          }
                        ],
                        staticClass: "line__wrap"
                      },
                      [
                        _c("div", { staticClass: "line__title" }, [
                          _vm._v("ASTRORG 粉丝专页")
                        ]),
                        _c("div", { staticClass: "line__sub" }, [
                          _vm._v(
                            "\n              占星大小事都在这，马上订阅掌握最新内容。\n            "
                          )
                        ]),
                        _c("div", { staticClass: "social__btn" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://www.facebook.com/astrorg.tw/",
                                target: "_blank",
                                rel: "noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/WebPage/social/icon-facebook - w.svg"),
                                  alt: "FB"
                                }
                              }),
                              _vm._v(
                                "\n                马上订阅\n              "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social === "Line",
                            expression: "social === 'Line'"
                          }
                        ],
                        staticClass: "line__wrap"
                      },
                      [
                        _c("div", { staticClass: "line__title" }, [
                          _vm._v("ASTRORG LINE@")
                        ]),
                        _c("div", { staticClass: "line__sub" }, [
                          _vm._v(
                            "\n              加入 LINE 好友，随时查看你的星盘与提醒。\n            "
                          )
                        ]),
                        _c("div", { staticClass: "social__btn" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "http://nav.cx/bfVg6A9",
                                target: "_blank",
                                rel: "noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/WebPage/social/icon-line - w.svg"),
                                  alt: "Line"
                                }
                              }),
                              _vm._v(
                                "\n                马上加入\n              "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.social === "IG",
                            expression: "social === 'IG'"
                          }
                        ],
                        staticClass: "line__wrap"
                      },
                      [
                        _c("div", { staticClass: "line__title" }, [
                          _vm._v("ASTRORG Instagram")
                        ]),
                        _c("div", { staticClass: "line__sub" }, [
                          _vm._v(
                            "\n              追踪最新占星内容与灵感，快速补给星知识。\n            "
                          )
                        ]),
                        _c("div", { staticClass: "social__btn" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://www.instagram.com/astrorg.tw/",
                                target: "_blank",
                                rel: "noreferrer"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/WebPage/social/icon-instagram - w.svg"),
                                  alt: "IG"
                                }
                              }),
                              _vm._v(
                                "\n                马上追踪\n              "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _c(
                  "v-flex",
                  { staticClass: "line__img", attrs: { xs12: "", md6: "" } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/WebPage/line-phone.png"),
                        alt: "社群"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "pan" }, [
        _c(
          "div",
          { staticClass: "index_container custom-container-xl" },
          [
            _c(
              "v-layout",
              {
                attrs: {
                  row: "",
                  wrap: "",
                  "fill-height": "",
                  "align-center": ""
                }
              },
              [
                _c(
                  "v-flex",
                  { staticClass: "pan__box", attrs: { xs12: "", md6: "" } },
                  [
                    _c("div", { staticClass: "pan__wrap" }, [
                      _c("div", { staticClass: "pan__title" }, [
                        _vm._v("连接科技与星座，")
                      ]),
                      _c("div", { staticClass: "pan__title" }, [
                        _vm._v("带你探索前所未有的占星体验！")
                      ]),
                      _c(
                        "div",
                        { staticClass: "pan__sub hidden-sm-and-down" },
                        [
                          _vm._v(
                            "\n              登录后可立即开始使用完整功能。\n            "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pan__btn cta-btn",
                          on: { click: _vm.toSinglePan }
                        },
                        [_vm._v("线上探索")]
                      )
                    ]),
                    _c("img", {
                      staticClass: "hidden-pad-down",
                      attrs: {
                        src: require("@/assets/WebPage/social/Group 6.svg"),
                        alt: "装饰"
                      }
                    })
                  ]
                ),
                _c(
                  "v-flex",
                  { staticClass: "pan__img", attrs: { xs12: "", md6: "" } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/WebPage/phone.png"),
                        alt: "phone"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "index_container custom-container-xl footer__inner" },
          [
            _vm._m(0),
            _c("div", { staticClass: "footer__links" }, [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/privacy-policy" })
                    }
                  }
                },
                [_vm._v("\n          隐私及服务条款\n        ")]
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.facebook.com/astrorg.tw/",
                    target: "_blank",
                    rel: "noreferrer"
                  }
                },
                [_vm._v("Facebook")]
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.instagram.com/astrorg.tw/",
                    target: "_blank",
                    rel: "noreferrer"
                  }
                },
                [_vm._v("Instagram")]
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer__brand" }, [
      _c("img", {
        attrs: { src: require("@/assets/WebPage/logo.png"), alt: "ASTRORG" }
      }),
      _c("div", { staticClass: "copyright" }, [
        _vm._v(
          "\n          Copyright © 2019 Astrorg. All rights reserved\n        "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }